<script setup>
import { computed, ref } from "vue";

import { useMainStore }     from "../stores/main";
import { storeToRefs } from "pinia";
import SvgNote         from "./SvgNote.vue";
import Tabs            from "./Tabs.vue";
import Tab             from "./Tab.vue";
import Cards        from "./Cards.vue";
import Card         from "./Card.vue";
import Modal         from "./Modal.vue";
import useSound             from "../composables/useSound";

let store = useMainStore();
let { playSound } = useSound();
const { lang, score, copydeck, currentUser } = storeToRefs(store);

let { getPreviousPage, packs, characters, decors, unlockItem, selectItem, isInInventory, isSelected, isAvailable, getCopydeckAudio } = store;
let previousPage = computed ( () => getPreviousPage());

const modalContent = ref('');
const showModal = ref(false);
const currentCost = ref(0);
const currentlySelected = ref(null);
const modalType = ref("");
const lastClickItem = ref(null);
let onYesCallback =  () => {} ;
const emits = defineEmits(["decor-selected", "character-selected", "pack-selected", "close"]);

function isUnlocked ()
{
    let item = currentlySelected.value;

    return false;
}
function canBuy ()
{
    let item = lastClickItem.value;

    let isLocked = !isInInventory(item);
    let cost = item.cost;

    let hasEnoughMoney = score.value >= cost;
    return isLocked && hasEnoughMoney;
}

function openModal(onYes) {
    showModal.value = true;
    onYesCallback = onYes;
    // modalYes.value = yesFunc;
    // modalNo.value = noFunc;
}

function closeModal() {
    showModal.value = false;
}


function doBtnAction (items, item)
{
    lastClickItem.value = item;

    if (item.unlocked || isInInventory(item))
    {
        select(items, item);
    }
    else
    {
        unlock(items, item);
    }
}

const unlock = function(items, item) {
    //modalContent.value = getModalContent(item.cost);
    currentCost.value = item.cost;

    if(score.value >= item.cost) {
        // wait for confirmation and THEN do things
        openModal(($) => handleBuyItem(items, item),);
    } else {
        openModal(false, closeModal);
    }
}

const handleBuyItem = function(items, item) {
    unlockItem(items, item);
    selectItem(items, item);
    //closeModal();
}

function onMusicPackSelected (item)
{
    let modal = isInInventory(item) ? "select" : "unlock";
    modalType.value = "pack";
    currentlySelected.value = item;

    if (modal == "select")
    {
        emits("pack-selected", item);
        return;
    }

    let canBuy = (score.value >= item.cost)
    let bubblePlay = getCopydeckAudio("game1", canBuy ? "unlock_music_pack" : "not_enough_notes");
    playTextAudio(bubblePlay.audios[lang.value].url);

    openModal( () =>
               {
                   handleBuyItem(packs, item);

                   emits("pack-selected", item);
               });
}
function onCharacterSelected(item)
{
    let modal = isInInventory(item) ? "select" : "unlock";
    modalType.value = "character";
    currentlySelected.value = item;

    if (modal == "select")
    {
        emits("character-selected", item);
        return;
    }

    let canBuy = (score.value >= item.cost)
    let bubblePlay = getCopydeckAudio("game1", canBuy ? "unlock_character" : "not_enough_notes");
    playTextAudio(bubblePlay.audios[lang.value].url);

    openModal( () =>
               {
                   handleBuyItem(characters, item);

                   emits("character-selected", item);
               });

}

function onDecorSelected(item)
{
    let modal = isInInventory(item) ? "select" : "unlock";

    if (modal == "select")
    {
        emits("decor-selected", item);

        return;
    }

    let canBuy = (score.value >= item.cost)
    let bubblePlay = getCopydeckAudio("game1", canBuy ? "unlock_decor" : "not_enough_notes")

    playTextAudio(bubblePlay.audios[lang.value].url);

    openModal( () =>
               {


                   handleBuyItem(decors, item);

                   emits("decor-selected", item);
               });

}
const select = function(items, item) {
    //if(!item.unlocked) return;
    selectItem(items, item);
}

function close ()
{
    emits("close");
}

function getBtnLabel (item)
{
    return item.unlocked || isInInventory(item) ? copydeck.value.extras.btn_choose[lang.value] : copydeck.value.extras.btn_unlock[lang.value];
}

function onModalSelection (choice)
{
    showModal.value = false;

    if (choice)
    {
        onYesCallback();
    }

}


function getModifyMessage ()
{

    let arrMessage = {
        "decor": copydeck.value.popup.changeDecor[lang.value],
        "character": copydeck.value.popup.changeCharacter[lang.value],
        "pack": copydeck.value.popup.changeMusicPack[lang.value],
        "n/a": "Veux-tu changer ?"
    }

    return `${arrMessage[lastClickItem?.value?.type ?? 'n/a']}`;
}

function cssClass (item)
{
    return {
        'unavailable': !isAvailable(item),
        'unlocked': item.unlocked || isInInventory(item),
        'selected' : isSelected(item),
        'locked': !isInInventory(item)
    }
}


function playTextAudio (url)
{
    if (!url || url === "")
        return;

    playSound(url,
              "narrator",
              {
                  "delay": 1,
                  "start":
                           {
                               "type": "fade",
                               "to": 0.25,
                               "duration": 750
                           },
                  "end":
                           {
                               "type": "fade",
                               "to": 1,
                               duration: 2000
                           }
              },
              {
                  start: () => {},
                  end: () =>  {}
              });

}

let strRemainingNotesTitle =  computed ( () => copydeck.value.extras.you_got[lang.value].replace("%s"));

</script>

<template>
    <div class="page-box extras">
        <h1 class="page-box-title" >{{ copydeck.extras.you_got[lang]}} <span class="notes-qty">{{score}} <SvgNote /></span></h1>



        <button @click="close" class="btn-icon btn-extras abs-right">

            <span class="sr-only">Close</span>
            <span class="button-text">X</span>
        </button>

        <Tabs>

            <Tab :title="copydeck.extras.title_music[lang]">
                <Cards>
                    <template v-for="(item, i) in packs" :key="`item-${i}`">
                        <Card
                            :label="item.name[lang]"

                            class2="{ 'unavailable': !isAvailable(item), 'unlocked': item.unlocked || isInInventory(item), 'selected' : isSelected(item), 'locked': !isInInventory(item) }"
                            :class="cssClass(item)"
                            :image="item.img"
                            @click="() => onMusicPackSelected(item)"
                        >
                            <template v-slot:header>
                                <p class="item-cost">{{ copydeck.popup.use[lang] }} <span class="notes-qty">{{ item.cost }}<SvgNote /></span></p>
                            </template>
                            <template v-slot:button>
                                <button class="btn-primary btn-choose" @click="() => doBtnAction(packs, item)"> {{ getBtnLabel(item) }}</button>
                            </template>
                        </Card>
                    </template>
                </Cards>
            </Tab>

            <Tab :title="copydeck.extras.title_character[lang]">
                <Cards>
                    <template v-for="(item, i) in characters">
                        <Card
                            :label="item.name[lang]"
                            :image="item.img"
                            :class="{ 'unavailable': !isAvailable(item), 'unlocked': item.unlocked || isInInventory(item), 'selected' : isSelected(item) , 'locked': !isInInventory(item)}"
                            @click="() => onCharacterSelected(item)"
                        >
                            <template v-slot:header>
                                <p class="item-cost">{{ copydeck.popup.useNote[lang] }} <span class="notes-qty">{{ item.cost }}<SvgNote /></span></p>
                            </template>
                            <template v-slot:button>
                                <button class="btn-primary btn-choose" @click="() => doBtnAction(characters, item)">{{ getBtnLabel(item) }}</button>
                            </template>
                        </Card>
                    </template>
                </Cards>
            </Tab>

            <Tab :title="copydeck.extras.title_decors[lang]" class="decors">
                <Cards>
                    <template v-for="(item, i) in decors">
                        <Card
                            :label="item.name[lang]"
                            :image="item.img"
                            :class="{ 'unavailable': !isAvailable(item), 'unlocked': item.unlocked || isInInventory(item), 'selected' : isSelected(item), 'locked': !isInInventory(item) }"
                            @click="() => onDecorSelected(item)"
                        >
                            <template v-slot:header>
                                <p class="item-cost">{{ copydeck.popup.use[lang] }} <span class="notes-qty">{{ item.cost }}<SvgNote /></span></p>
                            </template>
                            <template v-slot:button>
                                <button class="btn-primary btn-choose" @click="() => doBtnAction(decors, item)">{{ getBtnLabel(item) }}</button>
                            </template>
                        </Card>
                    </template>
                </Cards>
            </Tab>

        </Tabs>


        <Modal v-if="showModal"
            @onChoose="onModalSelection"
               showNo="true"
               :showYes="score >= currentCost"
            >
            <template v-slot:content>

                <div v-if="canBuy()">
                    <p>{{ copydeck.popup.useNote[lang] }} <span class="notes-qty">{{currentCost}}<SvgNote /></span> ?</p>

                </div>
                <div v-else>
                    <p>{{ copydeck.popup.notEnoughNotes[lang] }}</p>
                </div>

            </template>
        </Modal>

    </div>
</template>



<style scoped>

</style>
